export default __webpack_public_path__ + "static/media/portrait0.08970b71.png";